<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <form class="modal-content" v-on:submit.prevent="submit">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Merge Jobs</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div v-if="loading" class="block-content text-center">
                        <p class="h4 mb-4">Loading</p>
                    </div>
                    <div v-show="loading === false" class="block-content fs-sm">
                        <div class="row">
                            <div class="col-3 mb-4">
                                <label class="form-label" for="f_number">Number</label>
                                <select class="form-select" :class="{'is-invalid': errors.number}" id="f_number" v-model="jobNumber" required>
                                    <option v-for="number in jobDetails.map((job) => job.number)">
                                        {{ number }}
                                    </option>
                                </select>

                                <div v-if="errors.number" class="invalid-feedback">{{ errors.number.join(', ') }}</div>
                            </div>

                            <div class="col-6 mb-4">
                                <label class="form-label" for="f_description">Description</label>
                                <input type="text" class="form-control" :class="{'is-invalid': errors.description}" id="f_description" v-model="jobDescription" required>

                                <ul class="ps-4 pt-1">
                                    <li v-for="job in jobDetails">
                                        #{{ job.number }} - {{ job.description }}
                                    </li>
                                </ul>

                                <div v-if="errors.description" class="invalid-feedback">{{ errors.description.join(', ') }}</div>
                            </div>

                            <div class="col-3 mb-4">
                                <label class="form-label" for="f_status">Status</label>
                                <select class="form-select" :class="{'is-invalid': errors.status}" id="f_status" v-model="jobStatus" required>
                                    <option v-for="status in statuses">
                                        {{ status }}
                                    </option>
                                </select>

                                <ul class="ps-4 pt-1">
                                    <li v-for="job in jobDetails">
                                        #{{ job.number }} - {{ job.status }}
                                    </li>
                                </ul>

                                <div v-if="errors.status" class="invalid-feedback">{{ errors.status.join(', ') }}</div>
                            </div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label" for="f_staff">Staff</label>
                            <select class="form-select" :class="{'is-invalid': errors.staffUuids}" id="f_staff" ref="staffPicker" required multiple>
                            </select>

                            <ul class="ps-4 pt-1">
                                <li v-for="job in jobDetails">
                                    #{{ job.number }} - {{ job.staff.map((staff) => staff.both_names).join(', ') }}
                                </li>
                            </ul>

                            <div v-if="errors.staffUuids" class="invalid-feedback">{{ errors.staffUuids.join(', ') }}</div>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                        <button v-if="!loading" type="submit" class="btn btn-sm btn-success">Merge</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        reload: {
            type: Boolean,
            default: false,
        },
        routes: Object,
        statuses: Array,
    },
    data () {
        return {
            errors: [],
            jobDescription: '',
            jobDetails: [],
            jobNumber: '',
            jobStaff: [],
            jobStatus: '',
            jobUuids: [],
            loading: false,
            modal: null,
            route: null,
            staffPicker: null,
            submitText: 'Submit',
            title: '',
        };
    },
    mounted () {
        this.modal = new Modal(this.$el);

        Eventbus.on('classics-merge-jobs', async (jobUuids) => {
            this.loading = true;
            this.modal.show();
            this.jobDetails = [];
            this.jobUuids = jobUuids;
            await Promise.all(
                jobUuids.map((jobUuid) => axios.get(this.routes.get.replace('replace-me', jobUuid))
                    .then(({data}) => {
                        this.jobDetails.push(data);
                    })
                )
            );

            this.jobDetails.sort((a, b) => {
                return a.number > b.number;
            })

            this.jobNumber = this.jobDetails[0].number;
            this.jobDescription = this.jobDetails[0].description;
            this.jobStatus = this.jobDetails[0].status;

            // reset
            this.jobStaff = [];

            // combine
            for (const job of this.jobDetails) {
                this.jobStaff = this.jobStaff.concat(job.staff);
            }

            // index
            const staffUuids = this.jobStaff.map((staff) => staff.uuid);

            // deduplicate
            this.jobStaff = this.jobStaff.filter((staff, index) => staffUuids.indexOf(staff.uuid) === index);

            this.loading = false;
            setTimeout(this.createPicker, 50);
        });
    },
    methods: {
        createPicker () {
            // this needs to be recreated each open for some reason
            this.staffPicker = window.jQuery(this.$refs.staffPicker).select2({
                dropdownParent: this.$el,
                placeholder: 'Select Staff',
                ajax: {
                    cache: true,
                    data: function(params) {
                        return {
                            search: params.term,
                            page: params.page
                        };
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function(data) {
                        // why do we need to do this?
                        return {
                            results: data.data
                        };
                    },
                    url: this.routes.staffFilter,
                }
            });

            if (this.staffPicker.find('option').length) {
                this.staffPicker.find('option').remove();
            }

            for (let staff of this.jobStaff) {
                this.staffPicker.append(window.jQuery('<option selected>' + staff.both_names + '</option>').val(staff.uuid));
            }

            this.staffPicker.trigger('change');
        },
        submit () {
            this.loading = true;
            axios.post(this.routes.merge, {
                description: this.jobDescription,
                staffUuids: this.staffPicker.val(),
                number: this.jobNumber,
                status: this.jobStatus,
                jobUuids: this.jobUuids,
            }).then((response) => {
                if (response.data.success === true) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Merged jobs',
                        timer: 1500,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    this.modal.hide();
                    Eventbus.emit('jobs-merged');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not merge jobs',
                        text: 'Unknown error',
                    });
                }
            }).catch((error) => {
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }

                if (status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not merge jobs',
                        text: 'System error: ' + status,
                    });
                }
            }).then(() => {
                this.loading = false;
            });
        }
    }
}
</script>
